selectorsShowMore = {
  wrapper: '.custom-filter__wrapper',
  option: '.custom-filter__option'
}

const filterWrappers = document.querySelectorAll(selectorsShowMore.wrapper);

filterWrappers.forEach(filterWrapper => {
  let options = filterWrapper.querySelectorAll(selectorsShowMore.option);
  let optionsLength = options.length;
  let i = optionsLength;

  options.forEach(option => {
    if (i >= 8 && optionsLength > 7) {
      option.classList.add('js-hidden');
    }

    i--;
  });
});